import { YealinkExpansionModelCode, PolycomExpansionModelCode } from '../enums';
import { DeviceMetadata } from '../interfaces';

export const YEALINK_EXPANSION_METADATA: Record<YealinkExpansionModelCode, DeviceMetadata> = {
  'yealink-exp43': {
    buttonsCount: 60,
    deviceButtonsCount: 20,
    isPagingAvailable: true,
  },
};

export const POLYCOM_EXPANSION_METADATA: Record<PolycomExpansionModelCode, DeviceMetadata> = {
  'polycom-vvx-color': {
    buttonsCount: 84,
    deviceButtonsCount: 28,
    isPagingAvailable: true,
  },
  'polycom-vvx-em': {
    buttonsCount: 40,
    deviceButtonsCount: 40,
    isPagingAvailable: false,
  },
  'polycom-vvx-em50': {
    buttonsCount: 90,
    deviceButtonsCount: 30,
    isPagingAvailable: true,
  },
};

export const EXPANSION_METADATA = { ...YEALINK_EXPANSION_METADATA, ...POLYCOM_EXPANSION_METADATA };
